/* ─── Brand Logic ─────────────────────────────────────────────────────────── */
const EST_BRAND_LOGIC = {
  'Hermès':               { base: 1.125, scarcity: 1.10, retail_inc: 1.05, group: 'high' },
  'Goyard':               { base: 0.90,  scarcity: 1.10, retail_inc: 1.0,  group: 'high' },
  'Chanel':               { base: 0.69375, scarcity: 1.0, retail_inc: 1.05, group: 'high' },
  'Louis Vuitton':        { base: 0.825, group: 'standard' },
  'Dior':                 { base: 0.825, group: 'standard' },
  'Celine':               { base: 0.775, group: 'standard' },
  'Bottega Veneta':       { base: 0.775, group: 'standard' },
  'Loewe':                { base: 0.775, group: 'standard' },
  'Fendi':                { base: 0.725, group: 'standard' },
  'Prada':                { base: 0.70,  group: 'standard' },
  'Saint Laurent':        { base: 0.675, group: 'standard' },
  'Gucci':                { base: 0.625, group: 'standard' },
  'Valentino':            { base: 0.625, group: 'standard' },
  'Givenchy':             { base: 0.575, group: 'standard' },
  'Balenciaga':           { base: 0.525, trend: 0.90, group: 'trend' },
  'Chloé':                { base: 0.475, group: 'standard' },
  'Salvatore Ferragamo':  { base: 0.475, group: 'standard' },
  'Dolce & Gabbana':      { base: 0.475, trend: 0.90, group: 'trend' },
  'MCM':                  { base: 0.425, trend: 0.90, group: 'trend' },
  'Christian Louboutin':  { base: 0.425, trend: 0.90, group: 'trend' }
};

/* ─── State ───────────────────────────────────────────────────────────────── */
let estSelectedBrand = null;
let estScores = {
  exterior: null, corners: null, cracks: null, straps: null,
  structure: null, material: null, stitching: null, interior: null,
  odor: null, zippers: null, set: null
};

/* ─── Init ────────────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  renderEstBrandPills();

  // Remove error border on price input when user types
  const priceInput = document.getElementById('avg-resale');
  if (priceInput) {
    priceInput.addEventListener('input', () => priceInput.classList.remove('est-error-border'));
  }
});

/* ─── Brand Pills ─────────────────────────────────────────────────────────── */
function renderEstBrandPills() {
  const container = document.getElementById('brand-pills-container');
  if (!container) return;
  container.innerHTML = Object.keys(EST_BRAND_LOGIC)
    .sort()
    .map(brand => `<button onclick="estSelectBrand('${brand.replace(/'/g, "\\'")}', this)" class="choice-pill">${brand}</button>`)
    .join('');
}

function estSelectBrand(brand, el) {
  estSelectedBrand = brand;
  el.parentElement.querySelectorAll('button').forEach(b => b.classList.remove('pill-active'));
  el.classList.add('pill-active');
  document.getElementById('brand-pills-container').classList.remove('est-error-highlight');
}

/* ─── Diagnostic Pills ────────────────────────────────────────────────────── */
function estSetDiagnostic(cat, val, el) {
  estScores[cat] = val;
  el.parentElement.querySelectorAll('button').forEach(b => b.classList.remove('pill-active'));
  el.classList.add('pill-active');
  el.parentElement.classList.remove('est-error-highlight');
}

/* ─── Calculate ───────────────────────────────────────────────────────────── */
function calculateOfficialValuation() {
  // Clear previous errors
  document.querySelectorAll('.est-error-border, .est-error-highlight').forEach(el => {
    el.classList.remove('est-error-border', 'est-error-highlight');
  });

  if (!estSelectedBrand) {
    showError('Please select a brand');
    const bc = document.getElementById('brand-pills-container');
    if (bc) bc.classList.add('est-error-highlight');
    document.getElementById('brand-scroll-anchor').scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  const researchPrice = parseFloat(document.getElementById('avg-resale').value);
  if (!researchPrice || researchPrice <= 0) {
    showError('Please enter an average resale price');
    document.getElementById('avg-resale').classList.add('est-error-border');
    document.getElementById('price-scroll-anchor').scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  for (const key of Object.keys(estScores)) {
    if (estScores[key] === null) {
      showError(`Please complete Step: ${key.charAt(0).toUpperCase() + key.slice(1)}`);
      const stepEl = document.getElementById(`step-${key}`);
      if (stepEl) {
        const pills = stepEl.querySelector('.est-pills-flex, .est-pills-3col');
        if (pills) pills.classList.add('est-error-highlight');
        stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
  }

  const logic = EST_BRAND_LOGIC[estSelectedBrand];

  // Average the 9 physical condition fields
  const conditionFields = [
    estScores.exterior, estScores.corners, estScores.cracks, estScores.straps,
    estScores.structure, estScores.stitching, estScores.interior, estScores.odor, estScores.zippers
  ];
  const condAvg = conditionFields.reduce((a, b) => a + b, 0) / conditionFields.length;

  // Map average to rating + multiplier
  let ratingLabel = 'FAIR';
  let conditionMultiplier = 0.50;
  if      (condAvg >= 1.0)  { ratingLabel = 'PRISTINE';   conditionMultiplier = 1.05; }
  else if (condAvg >= 0.95) { ratingLabel = 'EXCELLENT';  conditionMultiplier = 1.00; }
  else if (condAvg >= 0.80) { ratingLabel = 'VERY GOOD';  conditionMultiplier = 0.85; }
  else if (condAvg >= 0.65) { ratingLabel = 'GOOD';       conditionMultiplier = 0.70; }

  // Brand strength multipliers
  let strengthMult = 1.0;
  if (logic.scarcity)   strengthMult *= logic.scarcity;
  if (logic.retail_inc) strengthMult *= logic.retail_inc;
  if (logic.trend)      strengthMult *= logic.trend;

  let finalPercent = logic.base * conditionMultiplier * strengthMult * estScores.set * estScores.material;
  finalPercent = Math.min(2.0, Math.max(0.25, finalPercent));

  const baseValuation = researchPrice * finalPercent;

  renderEstResults(baseValuation, ratingLabel);
}

/* ─── Render Results ──────────────────────────────────────────────────────── */
function formatRange(value) {
  const min = Math.round(value * 0.9).toLocaleString();
  const max = Math.round(value * 1.1).toLocaleString();
  return `$${min} — $${max}`;
}

function renderEstResults(baseValuation, ratingLabel) {
  const resultEl = document.getElementById('estimate-result');
  resultEl.classList.remove('est-hidden');

  resultEl.innerHTML = `
    <div class="est-result-box">
      <div class="est-rating-badge">Condition Rating: ${ratingLabel}</div>

      <p class="est-result-label">Estimated Market Range</p>
      <div class="est-result-value">${formatRange(baseValuation)}</div>
      <p class="est-result-disclaimer">
        <strong>Estimates are based on your reported assessment of condition and are non-binding. Final offers are subject to verification and determination by the UNOO team.</strong>
      </p>

      <div class="est-options-grid">

        <!-- Self Sell -->
        <div class="est-option-card est-card-gray">
          <div class="est-option-content">
            <p class="est-option-label" style="color:#9ca3af">SELF SELL</p>
            <p class="est-option-value">${formatRange(baseValuation * 0.95)}</p>
          </div>
          <button onclick="window.open('https://www.skool.com/unoo-world-of-handbags-4343/about', '_blank')" class="est-option-btn est-btn-purple">JOIN COMMUNITY</button>
        </div>

        <!-- Consignment -->
        <div class="est-option-card est-card-purple">
          <div class="est-option-content">
            <p class="est-option-label" style="color:#a855f7">CONSIGNMENT</p>
            <p class="est-option-value" style="color:#a855f7">${formatRange(baseValuation * 0.72)}</p>
          </div>
          <div id="process-start-node-consignment">
            <button onclick="revealContactOptions('consignment')" class="est-option-btn est-btn-purple">SELL NOW</button>
          </div>
          <div id="contact-options-node-consignment" class="est-hidden est-contact-options">
            <p class="est-contact-label">Select your preferred contact method:</p>
            <div class="est-contact-grid">
              <a href="sms:+13467926767?&body=Hi%20UNOO%2C%20I%E2%80%99d%20like%20a%20consignment%20quote." class="est-contact-btn">TEXT</a>
              <a href="https://wa.me/13467926767?text=Hi%20UNOO%2C%20consignment%20quote%20please." target="_blank" class="est-contact-btn">WHATSAPP</a>
              <a href="https://www.instagram.com/unooworldofhandbags" target="_blank" class="est-contact-btn">INSTAGRAM</a>
            </div>
          </div>
        </div>

        <!-- Cash Out -->
        <div class="est-option-card est-card-black">
          <div class="est-option-content">
            <p class="est-option-label" style="color:#6b7280">CASH OUT</p>
            <p class="est-option-value" style="color:#fff">${formatRange(baseValuation * 0.52)}</p>
          </div>
          <div id="process-start-node-buyout">
            <button onclick="revealContactOptions('buyout')" class="est-option-btn est-btn-white">CASH QUOTE</button>
          </div>
          <div id="contact-options-node-buyout" class="est-hidden est-contact-options">
            <p class="est-contact-label" style="color:#9ca3af">Select your preferred contact method:</p>
            <div class="est-contact-grid">
              <a href="sms:+13467926767?&body=Hi%20UNOO%2C%20I%E2%80%99d%20like%20a%20cash%20buyout%20quote." class="est-contact-btn">TEXT</a>
              <a href="https://wa.me/13467926767?text=Hi%20UNOO%2C%20cash%20buyout%20quote%20please." target="_blank" class="est-contact-btn">WHATSAPP</a>
              <a href="https://www.instagram.com/unooworldofhandbags" target="_blank" class="est-contact-btn">INSTAGRAM</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  `;

  setTimeout(() => resultEl.scrollIntoView({ behavior: 'smooth', block: 'center' }), 200);
}

/* ─── Contact Toggle ──────────────────────────────────────────────────────── */
function revealContactOptions(suffix) {
  const start   = document.getElementById(`process-start-node-${suffix}`);
  const options = document.getElementById(`contact-options-node-${suffix}`);
  if (!start || !options) return;

  const isHidden = options.classList.contains('est-hidden');

  // Close the other one first
  const other = suffix === 'consignment' ? 'buyout' : 'consignment';
  const otherStart   = document.getElementById(`process-start-node-${other}`);
  const otherOptions = document.getElementById(`contact-options-node-${other}`);
  if (otherStart && otherOptions) {
    otherStart.classList.remove('est-hidden');
    otherOptions.classList.add('est-hidden');
  }

  if (isHidden) {
    start.classList.add('est-hidden');
    options.classList.remove('est-hidden');
  } else {
    start.classList.remove('est-hidden');
    options.classList.add('est-hidden');
  }
}

/* ─── Error Toast ─────────────────────────────────────────────────────────── */
function showError(msg) {
  const err = document.getElementById('validationError');
  err.textContent = msg;
  err.style.display = 'block';
  setTimeout(() => err.style.display = 'none', 3000);
}

/* ─── FAQ ─────────────────────────────────────────────────────────────────── */
window.toggleFaq = function (element) {
  const isActive = element.classList.contains('active');
  document.querySelectorAll('.faq-item').forEach(item => item.classList.remove('active'));
  if (!isActive) element.classList.add('active');
};

/* ─── Appointment Popup ───────────────────────────────────────────────────── */
window.openApptPopup = function () {
  document.getElementById('appt-popup-overlay').classList.add('appt-popup-visible');
  document.body.style.overflow = 'hidden';
};

window.closeApptPopup = function () {
  document.getElementById('appt-popup-overlay').classList.remove('appt-popup-visible');
  document.body.style.overflow = '';
};

// Close on backdrop click
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('appt-popup-overlay');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeApptPopup();
    });
  }
});

// Close on Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeApptPopup();
});
